var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwipeRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.436836,
    y: -0.436836,
    width: 13.1051,
    height: 13.1051,
    rx: 6.55254,
    transform: "matrix(0 -1 -1 0 14.0072 13.1488)",
    stroke: "#F8F8F8",
    strokeWidth: 0.873672
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72643 4.12083L9.63867 7.03307L6.72643 9.94531",
    stroke: "#F8F8F8",
    strokeWidth: 1.1649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwipeRight);
export default __webpack_public_path__ + "static/media/icon-swipe-right.bfca6db4f67ba6aae35ffd764b4189f7.svg";
export { ForwardRef as ReactComponent };